<div class="register">
    <div class="body" >
        <div class="upload-content">
            <fun-file-card [fileType]="'acreditationDoc'" [username]="userName" (getFile)="getFile($event)" (errorEvent)="errorFile()"></fun-file-card>
        </div>
    </div>
</div>
